import React, { useEffect, useState } from 'react';
import { ImageFrame } from '../../../media';
import VariableImage from '../../../media/VariableImage';
import { borderCssFromProps, BORDERLESS_BORDER } from '../../../../shared/boxes/borderStyles';
import { boxShadowCss } from '../../../../shared/boxes/shadowStyles';
import ImagePointsLayer from './ImagePointsLayer';

export default function HotspotImageBlock({
  src = '', srcVariable, srcSrcset = '', srcForm, alt = '',
  border = BORDERLESS_BORDER, shadow = 'none', ...props
}) {
  const [brokenSrc, setBrokenSrc] = useState(null);
  useEffect(() => setBrokenSrc(null), [src]);
  const isEditing = !!props.puck?.isEditing;
  const hasImage = !!src && src !== brokenSrc && (!srcVariable?.variableKey || !!srcVariable.variableValue);
  return (
    <ImagePointsLayer {...props} src={src} hasImage={hasImage} imageStyle={{ ...borderCssFromProps(border), boxShadow: boxShadowCss(shadow) }}>
      <VariableImage blockId={props.id} urlProp="src" src={src} binding={srcVariable} variableBox={srcForm?.showInForm} isEditing={isEditing} renderImage={(url) => (
        <ImageFrame src={url} srcSet={srcVariable?.variableKey ? '' : srcSrcset} alt={alt} mediaFit="contain" isEditing={isEditing} onError={() => setBrokenSrc(src)} />
      )} />
    </ImagePointsLayer>
  );
}
